import * as React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import SearchIcon from "@mui/icons-material/Search";
import { Paper } from "@material-ui/core";
import { IconButton, InputBase, TextField } from "@mui/material";
import {
  GetProductsRequest,
  SearchProductsResponse,
} from "../models/store.model";
import { SearchProducts } from "../service/store.service";
import { useMutation } from "react-query";
import { ApiResultModel } from "../../models/common.model";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import SearchField from "./searchField";

export default function Header(props: any) {
  const history = useHistory();
  const [data, setData] = React.useState<SearchProductsResponse>();
  // const searchProduct = useMutation(SearchProducts, {
  //   onSuccess: (result: ApiResultModel<SearchProductsResponse>) => {
  //     if (result) {
  //       setData(result.data);
  //     }
  //   },
  // });
  const [searchTerm, setSearchTerm] = useState("");
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      const search = {} as GetProductsRequest;
      search.productCategoryId = props?.parentCategoryId;
      search.filter = searchTerm;
      // searchProduct.mutate(search);
      // console.log(searchTerm)
      // alert('sfsdf')
    }, 3000);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  function gotoCategory() {
    history.push("/products/productCategory/ProductCategory");
  }
  return (
    <Box sx={{ width: "100%" }}>
      <Grid container xs={12} spacing={4}>
        {props.category ? (
          <Grid
            item
            xs={6}
            xl={2}
            lg={2}
            md={4}
            sm={4}
            style={{ maxWidth: "fit-content" }}
          >
            <div onClick={gotoCategory}>
              <MenuOpenIcon />
              <span className="colorBase fontWeight textFont14">
                دسته بندی ها
              </span>
            </div>
          </Grid>
        ) : (
          ""
        )}
        {props.category === true && props.search === true ? (
          <Grid item xs={1} style={{ maxWidth: "fit-content" }}>
            <span style={{ color: "#CFD8DC" }}>|</span>
          </Grid>
        ) : (
          ""
        )}
        {/* {props.search ? (
          <Grid item xs={3} style={{ marginTop: "-9px" }}>
            <SearchIcon />
            <InputBase
              // autoFocus
              type="text"
              autoComplete="off"
              className="live-search-field"
              placeholder="جستجو"
              // defaultValue='جستجو'
              style={{
                color: "#424242",
                fontSize: "14px",
                fontWeight: "bold",
                marginRight: "10px",
              }}
              sx={{
                input: {
                  color: "#424242",
                  "&::placeholder": {
                    opacity: 1,
                  },
                },
              }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Grid>
        ) : (
          ""
        )} */}
        <Grid item xs={6} xl={9} lg={9} md={7} sm={7} marginTop={"-9px"}>
          <SearchField />
        </Grid>
      </Grid>
      <hr
        style={{ marginRight: "-4vh", marginLeft: "-3.5vh", color: "#CFD8DC" }}
      />
    </Box>
  );
}
